import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FilterComponent } from './FilterComponent';
import React from 'react';
import { Switch } from 'antd';

export const InverseToggleFilter: FilterComponent<boolean | undefined> = (props) => {
	const { format, id, onChange, value } = props;

	return (
		<FilterComponent
			{ ...props }
			display='inline-reverse'
			tagProps={ {
				clearValue: false,
				value: value ? undefined : COPY_SPECIFIC.YES
			} }>
			<Switch
				checked={ value === undefined || value === null }
				className='toggle-filter'
				onChange={ (checked) => {
					onChange({
						[ id ]: {
							format,
							value: checked ? undefined : false
						}
					});
				} } />
		</FilterComponent>
	);
};
